import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useEffect, useState } from "react";

import ChatHistory from "../ChatHistory/ChatHistory";
import React from "react";
import ReactTost from "../../ReactTost";
import UserAddBot from "../Modal/UserAddBot";
import UserBotDelete from "../Modal/UserBotDelete";
import UserChatBotEmbed from "./UserChatBotEmbed";
import UserChatBotInterface from "./UserChatBotInterface";
import UserChatBotSetting from "./UserChatBotSetting";
import UserChatBotSources from "./UserChatBotSources";
import UserChatbotData from "./UserChatbotData";
import UserCreateBot from "./UserCreateBot";
import axios from "axios";
import { useTranslation } from "react-i18next";

const UserBotsNew = () => {
  const [tabIndex, setTabIndex] = useState("");
  const [deleteBotId] = useState();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [getBots, setGetBots] = useState(true);
  const [botId, setBotId] = useState();
  const [docList] = useState([]);
  const user = localStorage.getItem("id");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [botList, setBotList] = useState([]);
  const [addModalShow, setAddModalShow] = useState(false);
  const [botAll, setBotAll] = useState([]);

  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getAllBots = async () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/user/${user}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setBotList(response.data);
          setGetBots(false);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  function fetchData() {
    axios
      .get(`${API_URL}/${API_VERSION}/user_doc?id=${user}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
      })
      .catch((error) => {
        console.log("doc", error);
      });
  }


  function createBot(data) {
    if (data && user) {
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot`,
          {
            name: data,
            user,
            settings: {
              model: "gpt-3.5-turbo",
              temperature: 0,
              messageLimit: 100,
              visibility: "private",
            },
            chatInterface: {
              logoName: "https://seekicon.com/free-icon-download/chat_7.svg",
            },
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setTimeout(() => {
            navigate(`/my-bots/${response.data.botId}`);
          }, 1000);
          setGetBots(true);
          setBotList((prevBotList) => {
            const newBotList = [...prevBotList, response.data];
            const newIndex = newBotList.findIndex(
              (bot) => bot.id === response.data.botId
            );
            return newBotList;
          });
          setType("Success");
          setMessage(t("Your bot is created."));
          setShowAlert(true);
        })
        .catch((error) => {
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  const callGetBot = async (selectedId) => {
    // console.log("selectedId",selectedId);
    if (selectedId) {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/${selectedId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setBotAll((prevBotAll) => ({
            ...prevBotAll,
            id: response.data,
          }));
        })
        .catch((error) => {
          console.log(error);
        });
      }
    };
  useEffect(() => {
    getAllBots();
  }, [id]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (botList && id) {
      const selectedId = botList.findIndex((b) => {
        const myId = JSON.stringify(b.id) === JSON.stringify(id);
        return myId;
      });
      //  setBotId(id);
      setTabIndex(selectedId);
      callGetBot(id);
    }
  }, [botList]);

  return (
    <>
      {!id || botList.length === 0 ? (
        <UserCreateBot />
      ) : (
        <section className="creatnewbot userbots_main">
          <ReactTost
            onHide={() => {
              setShowAlert(false);
              setType("");
              setMessage("");
            }}
            alertClass={type}
            alertMessage={message}
            alertDo={showAlert}
          />
          <Container>
            <Row>
              <Col>
                <Tabs
                  onSelect={(index) => setTabIndex(index)}
                  selectedIndex={tabIndex}
                >
                  <Row>
                    <Col lg={3}>
                      <div className="addbtn">
                        <Link
                          className="userbutton"
                          onClick={() => setAddModalShow(true)}
                        >
                          <i className="fa-solid fa-circle-plus"></i>{" "}
                          {t("New Chatbot")}
                        </Link>
                      </div>
                      <div className="scrollsticky">
                        <TabList
                          className="nav flex-lg-column nav-pills"
                          onSelect={(index) => {
                            alert(botList[index].id);
                            setBotId(botList[index].id);
                          }}
                        >
                          {botList &&
                            botList.map((bot, index) => {
                              const counter =
                                index < 9 ? `0${index + 1}` : index + 1;
                              return (
                                <Tab Tab key={index}>
                                  <Link to={`/my-bots/${bot.id}`}>
                                    <div className="cardflex">
                                      <div className="cont">
                                        <div className="botname">
                                          {bot.name}
                                        </div>
                                        <div className="num">
                                          <span>{counter}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </Tab>
                              );
                            })}
                        </TabList>
                      </div>
                    </Col>
                    <Col lg={9}>
                      <div className="tabpanel">
                        {botAll &&
                          botList.map((bot, index) => (
                            <TabPanel className="tab-pane haschild">
                              <Tabs>
                                <TabList className="chat_bot_tab nav">
                                  <Tab>{t("Settings")}</Tab>
                                  <Tab>{t("Knowlegde Base")}</Tab>
                                  <Tab>{t("Try your bot")}</Tab>
                                  <Tab>{t("Embed on Site")}</Tab>
                                  <Tab>{t("Chatbot History")}</Tab>
                                  <Tab>{t("Chat Interface")}</Tab>
                                </TabList>
                                <TabPanel>
                                  <UserChatBotSetting/>
                                </TabPanel>
                                <TabPanel>
                                  <UserChatBotSources
                                    botData={botAll.id}
                                    docData={docList ? docList : []}
                                  />
                                </TabPanel>
                                <TabPanel>
                                  <UserChatbotData botData={botAll.id} />
                                </TabPanel>
                                <TabPanel>
                                  <UserChatBotEmbed botData={botAll.id} />
                                </TabPanel>
                                <TabPanel>
                                  <ChatHistory />
                                </TabPanel>
                                <TabPanel>
                                  <UserChatBotInterface botData={botAll.id} />
                                </TabPanel>
                              </Tabs>
                            </TabPanel>
                          ))}
                      </div>
                    </Col>
                  </Row>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      <UserAddBot
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        createBot={createBot}
      />
      
      {/* <UserBotDelete
        show={deleteModalShow}
        deleteBotId={deleteBotId}
        getBots={getBots}
        // getBotId={callGetBot}
        onHide={() => {
          setDeleteModalShow(false);
        }}
      /> */}
    </>
  );
};
export default UserBotsNew;
